import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

import Cotizacion from "../../../components/CotizacionFinanciero/CotizacionResponsabilidad/CotizacionResponsabilidad";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchObtenerDataResponsabilidad,fetchListarCotizadores,fetchConsultarCarritoResponsabilidad,fetchListarProvinciasResponsabilidad,
  fetchGirosNegocioFinanciero,fetchGirosNegocioFinanciero2 } from "../../../redux/actions/aRamoLineaFinanciera";
import {encriptarTramaAES} from "../../../utils/Encriptar/index";
import { ambienteAplicacion } from '../../../constants/urls';
import {sucursalesFetch } from "../../../redux/actions/aRamos";

class ContainerCotizacionResponsabilidad extends React.Component {
  constructor(props) {
    super(props)
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      Cotizador :{
        areaCotizador: '' , 
        nombreCotizador: '',
        idProducto:  queryParams.get('idProducto'),
      },
      idCarrito:  queryParams.get('id'),
      cargando:true
    }

  }

  async componentDidMount() {
    const { Cotizador,idCarrito } = this.state;
    const {idProducto} = Cotizador;
    await this.props.consultarCarrito('');   

    if(idProducto!== null){
      await this.props.listarCotizadores(ambienteAplicacion);
      let elemento = this.props.datosListarCotizadores.listarCotizadores.find(element => element.segCodigoCore === parseInt(idProducto , 10 ));
      if(elemento !== undefined){
        this.setState(prevState => ({ Cotizador: { ...prevState.Cotizador, areaCotizador: `${elemento.segAreaCotizador}`,nombreCotizador: `${elemento.segNombre}` }}))
        await this.props.listarDatos({"empresa": "AIGMETROPOLITANA", "areaCotizador": elemento.segAreaCotizador });
      }
    }else if(idCarrito!==null){
      /*Consulta Carrito*/  
      const datosJSON = {
        idCarrito: idCarrito
      }
      const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));  
      this.setState(prevState => ({ Cotizador: { ...prevState.Cotizador, areaCotizador: `${this.props.detalleCarrito.datosCarritoResponsabilidad.carAreaCotizador}`, 
      nombreCotizador: `${this.props.detalleCarrito.datosCarritoResponsabilidad.carDescripcionSeguro}`,
      idProducto: `${this.props.detalleCarrito.datosCarritoResponsabilidad.carSeguro}`,}}))
      await this.props.listarDatos({"empresa": "AIGMETROPOLITANA", "areaCotizador": this.props.detalleCarrito.datosCarritoResponsabilidad.carAreaCotizador});
      ;
    } 
    
    await this.props.listarProvincias();
    await this.props.fethSucursales();
    await this.props.listarGirosNegocio2(idProducto);
    // if(idProducto && (idProducto === 123 || idProducto === '123'))
    // {
    //   await this.props.listarGirosNegocio2(idProducto);
    // }
    // else{
    //   await this.props.listarGirosNegocio();
    // }    
    this.setState({
      cargando:false
    })
  }

  render() {
    const {dataResponsabilidad, datosListarCotizadores,detalleCarrito,listarProvinciasR,listaGirosNegocio,listaSucursales}= this.props;
    const {Cotizador,cargando}= this.state;
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
              loading={cargando || dataResponsabilidad.obtenerDataResponsabilidadIsLoading || datosListarCotizadores.listarCotizadoresIsLoading 
                || listarProvinciasR.listarProvinciasResponsabilidadIsLoading || detalleCarrito.consultarCarritoResponsabilidadIsLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando datos..."
            >
              {!cargando &&
                <Cotizacion listarProvincias={listarProvinciasR.listaProvinciasResponsabilidad} 
                detalleCarrito={detalleCarrito.datosCarritoResponsabilidad} dataResponsabilidad={dataResponsabilidad.datosResponsabilidad} Cotizador={Cotizador}
                listaGirosNegocio={listaGirosNegocio.datosGirosNegocio} listaSucursales={listaSucursales}/>
              }
          </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  detalleCarrito : state.datosCarritoResponsabilidad,
  listarProvinciasR : state.datosProvinciasResponsabilidad,
  datosListarCotizadores : state.datosListarCotizadores,
  dataResponsabilidad : state.dataResponsabilidad,
  listaGirosNegocio :state.girosNegocioFinanciero,
  listaSucursales: state.datosSucursales.DataSucursales
});

const mapDispatchToProps = dispatch => {
  return {
    listarDatos: data => dispatch(fetchObtenerDataResponsabilidad(data)),
    listarCotizadores: (datos) => dispatch(fetchListarCotizadores(datos)),
    listarProvincias: () => dispatch(fetchListarProvinciasResponsabilidad()),
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoResponsabilidad(data)),
    listarGirosNegocio: () => dispatch(fetchGirosNegocioFinanciero()),
    listarGirosNegocio2: (prod) => dispatch(fetchGirosNegocioFinanciero2(prod)),
    fethSucursales: () => dispatch(sucursalesFetch()),
  };
};

  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ContainerCotizacionResponsabilidad)
  );